export default __webpack_public_path__ + "static/media/shopify.8af8050a.svg";